import { extractLink } from '@atlaskit/link-extractors';
import { getActionsFromJsonLd } from '../../common/actions/extractActions';
import { CardAction } from '../../../view/Card/types';
import { canShowAction } from '../../../utils/actions/can-show-action';
export var extractViewAction = function extractViewAction(data, actionOptions) {
  if (!canShowAction(CardAction.ViewAction, actionOptions)) {
    return;
  }
  var viewActionExists = getActionsFromJsonLd(data).find(function (action) {
    return action['@type'] === 'ViewAction';
  });
  if (viewActionExists) {
    return {
      viewUrl: extractLink(data)
    };
  }
  return undefined;
};